/* CaptureNameRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;

class CaptureNameRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("capture-name-gl"); //TODO Setup the root Element
        this._rootElem.component = this._model;

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._nameField = new InputTextControl({
            darkTheme: true,
            placeholder: "Enter a name for this Snapshot (optional)"
        });
        this._confirmButton = new ButtonControl({
            label: "Start Capture",
            darkTheme: true
        });
        this._scheduleButton = new ButtonControl({
            label: "Schedule Capture",
            darkTheme: true
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _registerListeners() {
        this._confirmButton.on("UserClick", (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this)));
        this._scheduleButton.on("UserClick", (this._onScheduleButtonClick = this._onScheduleButtonClick.bind(this)));
        this._nameField.on("UserKeyDown", (this._checkForImpliedConfirm = this._checkForImpliedConfirm.bind(this)));

        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
    }

    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._scheduleButton.removeAllListeners("UserClick");
        this._nameField.removeAllListeners("UserKeyDown");
        this._cancelButton.removeAllListeners("UserClick");
    }

    _onConfirmButtonClick() {
        this._callStartCapture();
    }

    _onScheduleButtonClick() {
        this._callSetSchedule();
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            this._callStartCapture();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._nameField.shutdown(), this._confirmButton.shutdown(), this._scheduleButton.shutdown(), this._cancelButton.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._nameField = undefined;
                this._confirmButton = undefined;
                this._cancelButton = undefined;
                this._scheduleButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._nameField.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._scheduleButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                setTimeout(() => {
                    this._nameField.focus();
                });
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onCancelButtonClick() {
        let err = new Error("user rejected");
        err.userRejected = true;
        this.model.cancelAction(err);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */

    /*******************************************/
    _callStartCapture() {
        this._model.startCapture(this._nameField.getValue());
    }

    _callSetSchedule() {
        this._model.setSchedule(this._nameField.getValue());
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = CaptureNameRenderer;
